<template>
  <div class="product_list_brand">
    <div class="product_list_brand__items">
      <p class="product_list_brand__items--adress">
        <a href="" class="phone" @click.prevent="disp"
          ><font-awesome-icon icon="filter"
        /></a>

        <router-link
          style="text-decoration: none; color: var(--font-color)"
          to="/"
        >
          فروشگاه اینترنتی شمع خورشید
        </router-link>

        <router-link
          style="text-decoration: none; color: var(--font-color)"
          :to="{ name: 'list', params: { id: this.$route.params.id } }"
        >
          / برند {{ this.$route.params.id }}
        </router-link>
      </p>
      <div class="product_list_brand__items--container">
        <div class="product_list_brand__items--container--nav">
          <ul class="product_list_brand__items--container--nav-ul">
            <font-awesome-icon icon="store" />
            مرتب سازی بر اساس :

            <a @click.prevent="active = 'v'" @click="filters" href="">
              <li
                class="product_list_brand__items--container--nav-ul-li"
                :class="[active == 'v' ? 'act' : '']"
              >
                پر بازدید ترین
              </li>
            </a>
            <a @click.prevent="active = 's'" @click="filters" href="">
              <li
                class="product_list_brand__items--container--nav-ul-li"
                :class="[active == 's' ? 'act' : '']"
              >
                پرفروش ترین
              </li>
            </a>
            <a @click.prevent="active = 'n'" @click="filters" href="">
              <li
                class="product_list_brand__items--container--nav-ul-li"
                :class="[active == 'n' ? 'act' : '']"
              >
                جدید ترین
              </li>
            </a>
            <a @click.prevent="active = 'ch'" @click="filters" href="">
              <li
                class="product_list_brand__items--container--nav-ul-li"
                :class="[active == 'ch' ? 'act' : '']"
              >
                ارزان ترین
              </li>
            </a>
            <a @click.prevent="active = 'ex'" @click="filters" href="">
              <li
                class="product_list_brand__items--container--nav-ul-li"
                :class="[active == 'ex' ? 'act' : '']"
              >
                گران ترین
              </li>
            </a>
          </ul>
        </div>
        <div class="product_list_brand__items--container--products">
          <div
            :key="(item, index)"
            v-for="(item, index) in cat"
            class="product_list_brand__items--container--products-item"
          >
            <router-link
              :to="{ name: 'detail', params: { id: item.slug } }"
              class="product_list_brand__items--container--products-item-link"
            >
              <p
                v-if="item.special_sale"
                class="product_list_brand__items--container--products-item-link-p"
              >
                فروش ویژه
              </p>
              <p
                v-if="item.special_offer"
                class="product_list_brand__items--container--products-item-link-p"
              >
                پیشنهاد ویژه
              </p>
              <img
                class="product_list_brand__items--container--products-item-link-img"
                :src="item.image"
                :alt="item.image"
              />
              <div
                v-if="item.inventory <= 5"
                class="product_list_brand__items--container--products-item-link-inventory"
              >
                موجودی :
                {{ item.inventory.toLocaleString("fa").toPersianDigits() }}
              </div>
              <p
                class="product_list_brand__items--container--products-item-link-name"
              >
                {{ item.name }}
              </p>
              <div
                class="product_list_brand__items--container--products-item-link-dec"
              >
                <p
                  class="product_list_brand__items--container--products-item-link-dec-p"
                  v-if="item.discount != 0"
                >
                  {{ item.price.toLocaleString("fa").toPersianDigits() }} تومان
                </p>
                <p
                  class="product_list_brand__items--container--products-item-link-dec-per"
                  v-if="item.discount != 0"
                >
                  {{ item.discount.toLocaleString("fa").toPersianDigits() }}٪
                </p>
              </div>
              <p
                v-if="item.discount == 0"
                class="product_list_brand__items--container--products-item-link-price"
              >
                {{ item.price.toLocaleString("fa").toPersianDigits() }}
                تومان
              </p>
              <p
                v-if="item.discount != 0"
                class="product_list_brand__items--container--products-item-link-price"
              >
                {{ item.dis_price.toLocaleString("fa").toPersianDigits() }}
                تومان
              </p>
              <div
                class="product_list_brand__items--container--products-item-link-color"
              >
                <div
                  :key="(collor, iindex)"
                  v-for="(collor, iindex) in item.colors"
                  class="product_list_brand__items--container--products-item-link-color-item"
                >
                  <div
                    :style="{ background: collor }"
                    v-if="iindex <= 2"
                    class="boom"
                  ></div>
                  <div
                    v-if="iindex == 2"
                    style="margin-top: -0.3em"
                    class="product_list_brand__items--container--products-item-link-color-more"
                  >
                    <!-- {{ iindex }} -->
                    +
                  </div>
                  <!-- {{ iindex }} -->
                </div>
                <!-- <div
                  class="product_list_brand__items--container--products-item-link-color-item"
                ></div>
                <div
                  class="product_list_brand__items--container--products-item-link-color-item"
                ></div> -->
              </div>
            </router-link>
          </div>
        </div>
        <div class="pagination-con">
          <paginate
            v-model="pagee"
            :page-count="page"
            :click-handler="clickCallback"
            :prev-text="'قبلی'"
            :next-text="'بعدی'"
            :container-class="'pagination'"
            :page-class="'page-item'"
          >
          </paginate>
        </div>
      </div>
    </div>
    <div class="product_list_brand__filters">
      <a @click.prevent="dispc" class="filtclose">
        <span class="xew">×</span> بستن
        <!-- <font-awesome-icon icon="times-circle" /> -->
      </a>
      <div class="product_list_brand__filters_con">
        <div class="product_list_brand__filters_con--header">
          دسته بندی
          <font-awesome-icon
            class="product_list_brand__filters_con--header--btn"
            icon="angle-down"
            @click="open"
          />
        </div>
        <div class="product_list_brand__filters_con--body">
          <div
            :key="(item, index)"
            v-for="(item, index) in caat"
            class="product_list_brand__filters_con--body-items"
          >
            <label class="checkbox">
              <span class="ttt">{{ item.name }}</span>
              <input
                v-model="OOOo"
                :value="item.id"
                @change="filters"
                type="checkbox"
                checked="checked"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="product_list_brand__filters_con">
        <div class="product_list_brand__filters_con--header">
          رنگ
          <font-awesome-icon
            class="product_list_brand__filters_con--header--btn"
            icon="angle-down"
            @click="open"
          />
        </div>
        <div class="product_list_brand__filters_con--body">
          <div
            :key="(item, index)"
            v-for="(item, index) in menu.colors"
            class="product_list_brand__filters_con--body-items"
          >
            <label class="checkbox">
              <span class="ttt">{{ item.name }}</span>
              <input
                v-model="colors"
                :value="item.id"
                @change="filters"
                type="checkbox"
                checked="checked"
              />
              <span class="checkmark"></span>
            </label>
            <div
              class="checke--color"
              :style="{ background: item.color }"
            ></div>
          </div>
        </div>
      </div>
      <div class="product_list_brand__filters_con">
        <div class="product_list_brand__filters_con--header">
          اسانس
          <font-awesome-icon
            class="product_list_brand__filters_con--header--btn"
            icon="angle-down"
            @click="open"
          />
        </div>
        <div class="product_list_brand__filters_con--body dropdooown">
          <div
            :key="(item, index)"
            v-for="(item, index) in menu.essences"
            class="product_list_brand__filters_con--body-items"
          >
            <label class="checkbox">
              <span class="ttt">{{ item.name }}</span>
              <input
                v-model="esa"
                :value="item.id"
                @change="filters"
                type="checkbox"
                checked="checked"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="product_list_brand__filters_con">
        <div class="product_list_brand__filters_con--header">
          جنس
          <font-awesome-icon
            class="product_list_brand__filters_con--header--btn"
            icon="angle-down"
            @click="open"
          />
        </div>
        <div class="product_list_brand__filters_con--body dropdooown">
          <div
            :key="(item, index)"
            v-for="(item, index) in menu.materials"
            class="product_list_brand__filters_con--body-items"
          >
            <label class="checkbox">
              <span class="ttt">{{ item.name }}</span>
              <input
                v-model="mat"
                :value="item.id"
                @change="filters"
                type="checkbox"
                checked="checked"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="product_list_brand__filters_con">
        <div class="product_list_brand__filters_con--header">
          جستجو در نتایج:
        </div>
        <div class="product_list_brand__filters_con--body">
          <div class="con">
            <input
              @change="filters"
              class="product_list_brand__filters_con--body-search"
              type="text"
              placeholder="نام محصول مورد نظر را بنویسید"
              v-model="search"
            />
            <font-awesome-icon icon="search" />
          </div>
        </div>
      </div>
      <div class="product_list_brand__filters_con-check">
        <label class="chkbx">
          <input @change="filters" value="y" v-model="exists" type="checkbox" />
          <span class="x"></span>
        </label>
        <p class="product_list_brand__filters_con-check--title">
          فقط کالاهای موجود
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Paginate from "vuejs-paginate";

export default {
  components: {
    Paginate,
  },
  data() {
    return {
      OOOo: [],
      pageshow: true,
      pagee: 0,
      page: 0,
      active: "",
      // flag: true
      search: "",
      esa: [],
      cat: [],
      menu: [],
      items: [],
      caat: [],
      colors: [],
      mat: [],
      brand: [],
      exists: [],
      userData: {
        name: this.$route.params.id,
        descript: `در این صفحه جزييات محصول ${name} همراه با رنگ ها و قیمت ${name} قرار گرفته شده است`,
      },
    };
  },
  // name: "sunCandle",
  metaInfo() {
    return {
      title: `${this.$route.params.id} - فروشگاه شمع خورشید`,
      meta: [
        {
          name: "description",
          content: `برند ${this.$route.params.id} ، همراه با جزيیات رنگ ، عکس و فیلتر های محصولات وجود دارد و شما می توانید محصولات مرتبط با این برند را در این صفحه مشاهده کنید`,
        },
        {
          property: "og:title",
          content: this.$route.params.id + " - فروشگاه شمع خورشید",
        },
        { property: "og:site_name", content: "فروشگاه شمع خورشید" },
        { property: "og:type", content: "product page" },
      ],
    };
  },
  watch: {
    $route(to, from) {
      var that = this;
      this.$store.state.load = true;
      this.userData.name = this.$route.params.id;
      if (window.innerWidth <= 1100) {
        $(".product_list_brand__filters").css("display", "none");
      }
      var id = this.$route.params.id;
      $.ajax({
        url: that.$store.state.url + "api/v1/products/brand/" + id + "/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          that.cat = data.results;
          that.page = data.lastPage;
          $.ajax({
            url:
              that.$store.state.url + "api/v1/products/brand-menu/" + id + "/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            type: "GET",
            success: function (data, textStatus, request) {
              that.caat = data.cats;
              that.menu = data;
              that.items = data.cats;
              that.$store.state.load = false;
            },
            error: function (request, textStatus, errorThrown) {
              if (request.state == 500) {
                that.$toastr.e("خطایی در سرور به وجود امده");
                that.$store.state.e500 = true;
              } else {
                that.$store.state.e404 = true;
                that.$toastr.e("خطا در برقراری ارتباط");
              }
            },
            complete: function () {},
          });
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    },
  },
  methods: {
    clickCallback(pageNum) {
      // console.log(pageNum);
      var that = this;
      this.$store.state.load = true;
      var id = this.$route.params.id;
      $.ajax({
        url:
          that.$store.state.url +
          "api/v1/products/brand/" +
          id +
          "/?page=" +
          pageNum +
          "&colors=" +
          this.colors +
          "&brands=" +
          this.brand +
          "&cats=" +
          this.OOOo +
          "&essences=" +
          this.esa +
          "&materials=" +
          this.mat +
          "&q=" +
          this.search +
          "&has_inventory=" +
          this.exists +
          "&order=" +
          this.active,
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          that.cat = data.results;
          $.ajax({
            url:
              that.$store.state.url + "api/v1/products/brand-menu/" + id + "/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            type: "GET",
            success: function (data, textStatus, request) {
              that.caat = data.cats;
              that.menu = data;
              that.items = data.cats;
              that.$store.state.load = false;
            },
            error: function (request, textStatus, errorThrown) {
              if (request.state == 500) {
                that.$toastr.e("خطایی در سرور به وجود امده");
                that.$store.state.e500 = true;
              } else {
                that.$store.state.e404 = true;
                that.$toastr.e("خطا در برقراری ارتباط");
              }
            },
            complete: function () {},
          });
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {
          scroll(0, 0);
        },
      });
    },
    filters() {
      var that = this;
      this.$store.state.load = true;
      var id = this.$route.params.id;
      this.pagee = 1;
      $.ajax({
        url:
          that.$store.state.url +
          "api/v1/products/brand/" +
          id +
          "?colors=" +
          this.colors +
          "&brands=" +
          this.brand +
          "&essences=" +
          this.esa +
          "&materials=" +
          this.mat +
          "&cats=" +
          this.OOOo +
          "&q=" +
          this.search +
          "&has_inventory=" +
          this.exists +
          "&order=" +
          this.active,
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          that.cat = data.results;
          that.page = data.lastPage;
          window.scrollTo(0, 0);
          $.ajax({
            url:
              that.$store.state.url + "api/v1/products/brand-menu/" + id + "/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            type: "GET",
            success: function (data, textStatus, request) {
              that.caat = data.cats;
              that.menu = data;
              that.items = data.cats;

              that.$store.state.load = false;
              if (window.innerWidth <= 1100) {
                $(".product_list_brand__filters").css("display", "none");
              }
            },
            error: function (request, textStatus, errorThrown) {
              if (request.state == 500) {
                that.$toastr.e("خطایی در سرور به وجود امده");
                that.$store.state.e500 = true;
              } else {
                that.$store.state.e404 = true;
                that.$toastr.e("خطا در برقراری ارتباط");
              }
            },
            complete: function () {},
          });
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    },
    disp() {
      $(".product_list_brand__filters").css("display", "list-item");
    },
    dispc() {
      $(".product_list_brand__filters").css("display", "none");
    },
    open(e) {
      // console.log(e.target.parentElement.parentElement.lastChild);
      $(e.target.parentElement.parentElement.lastChild).toggleClass(
        "dropdooown"
      );
      // if (e.target.parentElement.parentElement.offsetHeight <= 45) {
      //   $(e.target.parentElement.parentElement.lastChild).css(
      //     "display",
      //     "block"
      //   );
      //   $(e.target.parentElement.parentElement).css("height", "250px ");
      //   this.flag = false;
      // } else if (e.target.parentElement.parentElement.offsetHeight > 45) {
      //   $(e.target.parentElement.parentElement.lastChild).css(
      //     "display",
      //     "none"
      //   );
      //   if (window.innerWidth <= 500) {
      //     $(e.target.parentElement.parentElement).css("height", "32px ");
      //   } else if (window.innerWidth <= 800) {
      //     $(e.target.parentElement.parentElement).css("height", "39px ");
      //   } else {
      //     $(e.target.parentElement.parentElement).css("height", "45px ");
      //   }
      // }
    },
  },
  mounted() {
    $(window).resize(function () {
      if (window.innerWidth >= 800) {
        $(".product_list_brand__filters").css("display", "list-item");
      }
    });
  },
  created() {
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    // this.$store.state.load = false;
    var that = this;
    this.$store.state.load = true;
    // console.log(this.$route.params.id);
    var id = this.$route.params.id;
    $.ajax({
      url: that.$store.state.url + "api/v1/products/brand/" + id + "/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        that.cat = data.results;
        // var r = data.count / 16;
        // console.log(data);
        that.page = data.lastPage;
        // if (data.count % 16 == 0) {
        //   that.page = Math.trunc(data.count / 16);
        //   // console.log(that.page);
        // } else {
        //   that.page = Math.trunc(data.count / 16 + 1);
        //   // console.log(that.page, "plus");
        // }

        $.ajax({
          url: that.$store.state.url + "api/v1/products/brand-menu/" + id + "/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true,
          },
          type: "GET",
          success: function (data, textStatus, request) {
            that.caat = data.cats;
            that.menu = data;
            that.items = data.cats;
            that.$store.state.load = false;
            that.userData.name = that.items.name;
          },
          error: function (request, textStatus, errorThrown) {
            if (request.state == 500) {
              that.$toastr.e("خطایی در سرور به وجود امده");
              that.$store.state.e500 = true;
            } else {
              that.$store.state.e404 = true;
              that.$toastr.e("خطا در برقراری ارتباط");
            }
          },
          complete: function () {},
        });
      },
      error: function (request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function () {},
    });
  },
};
</script>
<style lang="scss">
// @import "~pretty-checkbox/src/pretty-checkbox.scss";
.product_list_brand {
  width: 100%;
  min-height: auto;
  // background: red;
  margin-top: 8em;
  display: flex;
  position: relative;

  &__filters {
    width: 18%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: 10%;
    right: 0.1%;
    font-size: 0.9em;
    margin-bottom: -0.5em;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: thin;
    // direction: rtl;
    // scrollbar-color: red blue;
    // z-index: 90000000000000000000000000000000;
    scrollbar-color: var(--bg-color) var(--bg-color);
    @media screen and (max-width: 5000px) {
      // z-index: 90000000000000000000000000000000;

      // display: none;
      // font-size: 0.7em;
      display: flex;
    }
    @media screen and (max-width: 1200px) {
      // z-index: 90000000000000000000000000000000;
      // display: none;
      width: 20%;
      // font-size: 0.7em;
      display: flex;
    }
    @media screen and (max-width: 1100px) {
      display: none;
      font-size: 1.1em;
      width: 100%;
      height: 100%;
      position: fixed !important;
      left: 50%;
      top: 0%;
      transform: translate(-50%, -0%);
      z-index: 500 !important;
      background: var(--bg-color);
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-width: thin;
      // scrollbar-color: red blue;
      scrollbar-color: var(--bg-color) var(--bg-color);
      // justify-content: center;
      // align-items: center;
      padding-left: 0.9em;
    }
    @media screen and (max-width: 500px) {
      display: none;
      font-size: 1.1em;
      width: 100%;
      height: 100%;
      position: fixed !important;
      left: 50%;
      top: 0%;
      transform: translate(-50%, -0%);
      z-index: 500 !important;
      background: var(--bg-color);
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-width: thin;
      // scrollbar-color: red blue;
      scrollbar-color: var(--bg-color) var(--bg-color);
      // justify-content: center;
      // align-items: center;
      padding-left: 0.7em;
    }
    &_con {
      background: #fff;
      width: 96%;
      height: auto;
      max-height: 200px;
      -webkit-box-shadow: 0 12px 12px 0 hsla(0, 0%, 71%, 0.11);
      box-shadow: 0 12px 12px 0 hsla(0, 0%, 71%, 0.11);
      border: 1px solid #dedede;
      margin: 0 0 10px;
      border-radius: 8px;
      display: flex;
      direction: rtl;
      flex-direction: column;
      // padding-bottom: 1.5em;
      @media screen and (max-width: 1100px) {
        width: 98.3%;
      }
      @media screen and (max-width: 800px) {
        max-height: 200px;
      }
      &-check {
        width: 98%;
        background-color: #fff;
        -webkit-box-shadow: 0 12px 12px 0 hsla(0, 0%, 71%, 0.11);
        box-shadow: 0 12px 12px 0 hsla(0, 0%, 71%, 0.11);
        border: 1px solid #dedede;
        margin: 0 0 10px;
        border-radius: 8px;
        display: flex;
        direction: rtl;
        // flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        overflow: hidden;
        height: 45px;
        transition: all 0.5s;
        padding: 1em;
        &--title {
          margin-right: 1em;
          font-size: 0.9em;
        }
      }
      &--header {
        position: relative;
        color: var(--font-color);
        letter-spacing: 0.2px;
        font-weight: 100;
        font-size: 14px;
        font-size: 1rem;
        line-height: 1.571;
        padding: 8px 16px 10px 15px;
        border-bottom: 1px solid #f2f2f2;
        margin-right: 6px;
        margin-left: 6px;
        height: 45px;
        display: flex;
        align-items: center;
        @media screen and (max-width: 1100px) {
          font-size: 1.2em;
        }
        @media screen and (max-width: 800px) {
          font-size: 0.9em;
        }
        @media screen and (max-width: 500px) {
          font-size: 0.7em;
          height: 35px;
        }
        &--btn {
          margin-top: 0.4em;
          display: flex;
          margin-right: auto;
          cursor: pointer;
        }
        path {
          pointer-events: none;
        }
      }
      &--body {
        display: flex;
        flex-direction: column;
        // height: 200px;
        scrollbar-width: thin;
        scrollbar-color: var(--main-color) var(--main-color);
        overflow-y: scroll;
        .con {
          display: flex;
          justify-content: center;
          align-items: center;
          // background: red;
          position: relative;
          margin-top: 1em;
          margin-bottom: 1em;
          border-radius: 8px;
          margin-right: auto;
          margin-left: auto;
          width: 98%;
          margin-right: 0.3em;
          svg {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translate(-50%, -50%);
            // width: 100%;
            // background: red;
            @media screen and (max-width: 500px) {
              font-size: 0.7em;
            }
          }
        }

        &-search {
          font-size: 0.8em;
          width: 100% !important;
          margin-right: auto;
          margin-left: auto;
          font-family: "yekan";
          position: relative;
          border-radius: 8px;
          font-size: 0.786rem;
          line-height: 2;
          color: #555;
          background: #f8f8f8;
          // background: red !important;
          border: 1px solid transparent;
          -webkit-transition: 0.15s ease-in;
          transition: 0.15s ease-in;
          letter-spacing: 0;
          padding: 7px 35px 8px 2px;
          outline: hidden;
          @media screen and (max-width: 800px) {
            font-size: 0.6em;
            width: 100% !important;

            padding: 4px 33px 4px 0px;
          }
          @media screen and (max-width: 500px) {
            font-size: 0.6em;
            width: 100% !important;
            padding: 4px 28px 4px 0px;
          }
          &:focus {
            background: var(--main-color);
            border: 1px solid var(--shrink);
          }
        }
        &-items {
          width: 100%;
          // background: red;
          display: flex;
          align-items: center;
          justify-content: center;
          // height: 50px;
          margin-bottom: 0em;
          @media screen and (max-width: 800px) {
            color: var(--font-color);
            font-size: 0.7em;
            display: list-item;
            list-style: none;
            margin-bottom: 0px;
            // list-style-position: inside;
            line-height: 15px;
            // padding-right: 35px;
            text-decoration: none;
          }
          @media screen and (max-width: 500px) {
            color: var(--font-color);
            font-size: 0.6em;
            list-style: none;
            display: list-item;
            margin-bottom: 0px;
            // list-style-position: inside;
            line-height: 15px;
            // padding-right: 35px;
            text-decoration: none;
          }
          .checke {
            width: 100%;
            display: flex;
            padding: 1em 0.2em;
            margin-right: 1em;
            font-size: 0.9em;
            align-items: center;

            &--span {
              margin-right: 1em;
            }
            &--spanEn {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              // background: red;
              width: 50%;
              font-size: 0.8em;
              color: #ccc;
              align-self: center;
              margin-left: 1em;
            }
          }
        }
        &-ul {
          padding-right: 15px;
          margin-top: 0.5em;
          padding-bottom: 1em;
          @media screen and (max-width: 800px) {
            font-size: 0.7em;
          }
          @media screen and (max-width: 500px) {
            font-size: 0.6em;
          }
          &--header {
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            margin-bottom: 10px;
            text-decoration: none;
            color: var(--font-color);

            svg {
              margin-left: 0.5em;
              margin-bottom: 0.1em;
            }
          }
          &--li {
            color: var(--font-color);
            font-size: 0.9em;
            display: list-item;
            margin-bottom: 10px;
            line-height: 20px;
            padding-right: 35px;
            text-decoration: none;
            @media screen and (max-width: 800px) {
              padding-right: 16px;
            }
            @media screen and (max-width: 500px) {
              padding-right: 16px;
            }
          }
        }
      }
    }
  }
  // &__filters {
  //   padding-top: 0.9em;
  //   // background: blue;
  //   width: 18%;
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   // background: red;
  //   position: sticky;
  //   top: 10%;
  //   right: 0.5%;
  //   font-size: 0.9em;
  //   height: 700px;
  //   margin-bottom: -0.5em;
  //   overflow-y: scroll;
  //   overflow-x: hidden;
  //   scrollbar-width: thin;
  //   scrollbar-color: var(--bg-color) var(--bg-color);
  //   // scrollbar-color: blue red;
  //   @media screen and (max-width: 5000px) {
  //     // display: none;
  //     // font-size: 0.7em;
  //     display: flex;
  //   }
  //   @media screen and (max-width: 1100px) {
  //     // display: none;
  //     font-size: 0.7em;
  //     display: flex;
  //   }
  //   @media screen and (max-width: 800px) {
  //     display: none;
  //     font-size: 1.1em;
  //     width: 100%;
  //     height: 100%;
  //     position: fixed !important;
  //     right: 0;
  //     top: 11%;
  //     z-index: 40;
  //     background: var(--bg-color);
  //   }
  //   @media screen and (max-width: 500px) {
  //     display: none;
  //     font-size: 1.1em;
  //     width: 100%;
  //     height: 100%;
  //     position: fixed !important;
  //     right: 0;
  //     top: 17%;
  //     z-index: 40;
  //     background: var(--bg-color);
  //     // overflow: scroll;
  //     // overflow-x: hidden;
  //     // scrollbar-width: thin;
  //     // scrollbar-color: var(--bg-color) var(--main-color);
  //     // display: none;
  //   }
  //   &--container {
  //     width: 98%;
  //     background-color: #fff;
  //     -webkit-box-shadow: 0 12px 12px 0 hsla(0, 0%, 71%, 0.11);
  //     box-shadow: 0 12px 12px 0 hsla(0, 0%, 71%, 0.11);
  //     border: 1px solid #dedede;
  //     margin: 0 0 10px;
  //     border-radius: 8px;
  //     display: flex;
  //     direction: rtl;
  //     flex-direction: column;
  //     // overflow: hidden;
  //     height: auto;
  //     // transition: all 0.5s;
  //     // background: olive;
  //     @media screen and (max-width: 800px) {
  //       // height: 39px;
  //     }
  //     @media screen and (max-width: 500px) {
  //       // height: 35px;
  //     }
  //     &-cbox-body {
  //       display: flex;
  //       flex-direction: column;
  //       // background: red;
  //       height: auto;
  //       // height: 400px;
  //       // border-bottom: 3px solid black;
  //       overflow: hidden;
  //       // max-height: 200px !important;
  //       // overflow-y: scroll;
  //       // overflow-x: hidden;
  //       &--check {
  //         width: 100%;
  //         // background: red;
  //         display: flex;
  //         align-items: center;
  //         justify-content: center;
  //         @media screen and (max-width: 800px) {
  //           font-size: 0.7em;
  //           // margin-top: 1em;
  //         }
  //         @media screen and (max-width: 500px) {
  //           font-size: 0.6em;
  //           // margin-top: 1em;
  //         }
  //         .checke {
  //           width: 100%;
  //           display: flex;
  //           padding: 1em 0.2em;
  //           margin-right: 1em;
  //           font-size: 0.9em;
  //           align-items: center;

  //           &--span {
  //             margin-right: 1em;
  //           }
  //           &--spanEn {
  //             display: flex;
  //             justify-content: flex-end;
  //             align-items: center;
  //             // background: red;
  //             width: 50%;
  //             font-size: 0.8em;
  //             color: #ccc;
  //             align-self: center;
  //             margin-left: 1em;
  //           }
  //         }
  //       }
  //       .con {
  //         // background: red;
  //         position: relative;
  //         margin-top: 1em;
  //         margin-bottom: 1em;
  //         border-radius: 8px;
  //         margin-right: auto;
  //         margin-left: auto;
  //         svg {
  //           position: absolute;
  //           right: 0;
  //           top: 50%;
  //           transform: translate(-50%, -50%);
  //           // width: 100%;
  //           // background: red;
  //           @media screen and (max-width: 500px) {
  //             font-size: 0.7em;
  //           }
  //         }
  //       }
  //       display: flex;
  //       &-search {
  //         font-size: 0.8em;
  //         width: 100% !important;
  //         margin-right: auto;
  //         margin-left: auto;
  //         font-family: "yekan";
  //         position: relative;
  //         border-radius: 8px;
  //         font-size: 0.786rem;
  //         line-height: 2;
  //         color: #555;
  //         background: #f8f8f8;
  //         // background: red !important;
  //         border: 1px solid transparent;
  //         -webkit-transition: 0.15s ease-in;
  //         transition: 0.15s ease-in;
  //         letter-spacing: 0;
  //         padding: 7px 28px 8px 2px;
  //         @media screen and (max-width: 800px) {
  //           font-size: 0.6em;
  //           width: 100% !important;

  //           padding: 4px 27px 4px 0px;
  //         }
  //         @media screen and (max-width: 500px) {
  //           font-size: 0.6em;
  //           width: 100% !important;

  //           padding: 4px 20px 4px 0px;
  //         }
  //         &:focus {
  //           background: var(--main-color);
  //           border: 1px solid var(--shrink);
  //         }
  //       }
  //       &-ul {
  //         padding-right: 15px;
  //         margin-top: 0.5em;
  //         padding-bottom: 1em;
  //         @media screen and (max-width: 800px) {
  //           font-size: 0.7em;
  //         }
  //         @media screen and (max-width: 500px) {
  //           font-size: 0.6em;
  //         }
  //         &--header {
  //           // color: red;
  //           display: flex;
  //           justify-content: flex-start;
  //           align-items: flex-end;
  //           margin-bottom: 10px;
  //           // background: red;
  //           svg {
  //             margin-left: 0.5em;
  //             margin-bottom: 0.1em;
  //           }
  //         }
  //         &-li {
  //           font-size: 0.9em;
  //           display: list-item;
  //           margin-bottom: 10px;
  //           line-height: 20px;
  //           padding-right: 35px;
  //           @media screen and (max-width: 800px) {
  //             padding-right: 16px;
  //           }
  //           @media screen and (max-width: 500px) {
  //             padding-right: 16px;
  //           }
  //         }
  //       }
  //     }

  //     &-cbox-header {
  //       position: relative;
  //       color: var(--font-color);
  //       letter-spacing: 0.2px;
  //       font-weight: 100;
  //       font-size: 14px;
  //       font-size: 1rem;
  //       line-height: 1.571;
  //       padding: 8px 16px 10px 15px;
  //       border-bottom: 1px solid #f2f2f2;
  //       margin-right: 6px;
  //       margin-left: 6px;
  //       height: 45px;
  //       @media screen and (max-width: 1100px) {
  //         font-size: 1.2em;
  //       }
  //       @media screen and (max-width: 800px) {
  //         font-size: 0.9em;
  //       }
  //       @media screen and (max-width: 500px) {
  //         font-size: 0.6em;
  //       }
  //       svg {
  //         cursor: pointer;
  //         // content: "\25BD";
  //         position: absolute;
  //         left: 16px;
  //         top: 55%;
  //         // font-size: 5em;
  //         color: var(--shrink);
  //         // -webkit-transform: rotate(180deg) translateY(60%);
  //         transform: translateY(-60%);
  //         // -webkit-transition: all 0.3s ease-in-out;
  //         transition: all 0.3s ease-in-out;
  //       }
  //       path {
  //         pointer-events: none;
  //       }
  //     }
  //   }
  // }
  &__items {
    // text-align: ;
    // display: flex;
    direction: rtl;
    // flex-direction: column;
    width: 82%;
    // background: red;
    // margin-right: 0.5em;
    // margin-left: auto;
    // align-items: center;
    @media screen and (max-width: 1100px) {
      // font-size: 0.5em;
      width: 100%;
    }
    @media screen and (max-width: 800px) {
      // font-size: 0.5em;
      width: 100%;
    }
    @media screen and (max-width: 500px) {
      // font-size: 0.5em;
      // width: 75%;
    }
    &--adress {
      margin-right: 0.6em;
      margin: 1em;
      align-self: flex-start;
      font-size: 0.8em;
      @media screen and (max-width: 800px) {
        font-size: 0.6em;
      }
      @media screen and (max-width: 500px) {
        font-size: 0.5em;
      }
    }
    &--container {
      width: 98%;
      height: auto;
      background: var(--main-color);
      border: 1px solid #ebe9e9;
      position: relative;
      margin-right: auto;
      margin-left: auto;
      // padding: 0 44px 0 130px;
      z-index: 2;
      // box-shadow: 0 0 5px rgba(0, 0, 0, 0.308);
      overflow: hidden;
      &--products {
        width: 100%;
        height: 100%;
        // background: red;
        display: flex;
        flex-wrap: wrap;
        &-item {
          // margin-top: -1em;
          width: 25%;
          height: 400px;
          // background: red;
          border-bottom: 1px solid #ebe9e9;
          border-left: 1px solid #ebe9e9;
          // border-top: 1px solid #ebe9e9;
          // border-right: 1px solid #ebe9e9;
          @media screen and (max-width: 1200px) {
            font-size: 0.9em;
            width: 33%;
            height: 350px;
            // padding-top: 1em;
          }
          @media screen and (max-width: 800px) {
            font-size: 0.9em;
            width: 33%;
            height: 350px;
            // padding-top: 1em;
          }
          @media screen and (max-width: 600px) {
            // font-size: 0.5em;
            width: 50%;
            height: 320px;
          }
          @media screen and (max-width: 500px) {
            // font-size: 0.5em;
            width: 100%;
            height: 320px;
          }
          &:not(:last-child) {
          }
          &-link {
            // background: red;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            text-decoration: none;
            position: relative;
            transition: all 0.3s;
            &:hover {
              box-shadow: 0 1px 5px rgba(0, 0, 0, 0.212);
              // transform: translate(0%, -5px);
            }
            &-inventory {
              width: 100%;
              font-size: 0.8em;
              color: var(--shrink);
              padding-right: 1em;
              margin-bottom: 0.5em;
              @media screen and (max-width: 800px) {
                font-size: 0.8em;
                // top: 10%;
              }
              @media screen and (max-width: 500px) {
                font-size: 0.7em;
                // top: 10%;
              }
            }
            &-name {
              width: 100%;
              color: var(--font-color);
              padding-right: 1em;
              font-size: 0.9em;
              @media screen and (max-width: 800px) {
                font-size: 0.8em;
                // top: 10%;
              }
              @media screen and (max-width: 500px) {
                font-size: 0.7em;
                // top: 10%;
              }
            }
            &-price {
              letter-spacing: 0.05em;
              word-spacing: 0.2em;
              font-size: 1.2em;
              // text-decoration: line-through;
              padding-left: 0.9em;
              text-align: left;
              width: 100%;
              // margin-top: 4em;
              color: var(--font-color);
              @media screen and (max-width: 800px) {
                font-size: 1em;
                // top: 10%;
              }
              @media screen and (max-width: 500px) {
                font-size: 0.9em;
                // top: 10%;
              }
            }
            &-color {
              // background: red;
              position: absolute;
              top: 0;
              right: 5%;
              width: 10px;
              height: 70px;
              // border-radius: 50%;
              transform: translate(-0%, 55%);
              display: flex;
              justify-items: center;
              flex-direction: column;
              @media screen and (max-width: 800px) {
                // top: -2%;
              }
              @media screen and (max-width: 500px) {
                top: -2%;
              }
              // justify-content: space-around;
              &-item {
                .boom {
                  margin-top: 0.1em;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  border: 1px solid var(--font-color);
                  // background-color: blue;
                  @media screen and (max-width: 800px) {
                    width: 10px;
                    height: 10px;
                  }
                  @media screen and (max-width: 500px) {
                    width: 8px;
                    height: 8px;
                  }
                }
              }
              &-more {
                // margin-top: -0.5em;
                color: var(--shrink);
              }
            }
            &-dec {
              display: flex;
              width: 100%;
              justify-content: flex-end;
              text-align: left;
              color: var(--font-color);
              @media screen and (max-width: 800px) {
                font-size: 0.8em;
                // top: 10%;
              }
              @media screen and (max-width: 500px) {
                font-size: 0.7em;
                // top: 10%;
              }
              // padding-left: 1em;
              &-per {
                margin-right: 0.5em;
                margin-left: 0.8em;
                margin-top: 0.2em;
                color: var(--main-color);
                background: var(--sub-color);
                border-radius: 20px;
                padding: 0.4em 0.8em;
                font-size: 0.8em;
              }
              &-p {
                font-size: 0.9em;
                text-decoration: line-through;
                // padding-left: 0.9em;
                text-align: left;
                width: 100%;
                // margin-top: 4em;
                color: var(--font-color);
              }
            }
            &-p {
              color: var(--shrink);
              border-bottom: 1px solid var(--shrink);
              width: 100%;
              text-align: center;
              padding-bottom: 0.25em;
              margin-bottom: 0.5em;
              margin-top: -1.5em;
              position: absolute;
              top: 10%;
              transform: translate(0, -50%);
              @media screen and (max-width: 800px) {
                font-size: 0.9em;
                top: 10%;
              }
              @media screen and (max-width: 500px) {
                font-size: 0.7em;
                top: 10%;
              }
            }
            &-img {
              width: 200px;
              height: 200px;
              @media screen and (max-width: 800px) {
                width: 170px;
                height: 170px;
              }
              @media screen and (max-width: 500px) {
                width: 150px;
                height: 150px;
              }
            }
          }
        }
      }
      &--nav {
        display: flex;
        width: 100%;
        // height: 50px;
        // z-index: 90;
        background: var(--main-color);
        border-bottom: 1px solid #ebe9e9;
        @media screen and (max-width: 800px) {
          font-size: 0.7em;
        }
        @media screen and (max-width: 500px) {
          font-size: 0.4em;
        }
        &-ul {
          display: flex;
          font-size: 0.9em;
          margin: 0.7em;
          align-items: center;
          svg {
            margin-left: 0.3em;
          }
          a {
            text-decoration: none;
          }
          &-li {
            color: var(--font-color);
            font-size: 0.85em;
            margin: 0 0.2em;
            border-radius: 10px;
            padding: 0.2em 0.8em;
          }
        }
      }
    }
  }
}
.act {
  background: var(--shrink);
  color: var(--main-color);
}
// Switcher - Bootstrap's Check Button
// Still improving...
// $background: #233d4d;
// var(--shrink): #d3d3be;
.chkbx input[type="checkbox"] {
  display: none;
}

.chkbx {
  position: relative;
  cursor: pointer;
  .x {
    display: block;
    width: 55px;
    height: 26px;
    border: 1px solid var(--shrink);
    border-radius: 60px;
    transition: 0.5s;
    background: var(--main-color);
    @media screen and (max-width: 800px) {
      width: 25px;
      height: 16px;
      font-size: 0.5em;
    }
    @media screen and (max-width: 500px) {
      width: 25px;
      height: 16px;
      font-size: 0.5em;
    }
    &:before {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      top: 3px;
      left: 5px;
      box-sizing: border-box;
      background: var(--bg-color);
      border: 1px solid var(--font-color);
      border-radius: 40px;
      transition: 0.5s;
      @media screen and (max-width: 800px) {
        width: 10px;
        height: 10px;
        left: 3px;
      }
      @media screen and (max-width: 500px) {
        width: 10px;
        height: 10px;
        left: 3px;
      }
    }
  }
  :checked ~ .x:before {
    background: var(--main-color);
    border-color: var(--main-color);
    transform: translatex(25px);
    @media screen and (max-width: 800px) {
      transform: translatex(10px);
    }
    @media screen and (max-width: 500px) {
      transform: translatex(10px);
    }
  }
  :checked ~ .x {
    background: var(--shrink);
    border-color: var(--shrink);
  }
}
.checke--color {
  width: 15px;
  height: 12px;
  margin-left: 1em;
  border-radius: 50%;
  border: 1px solid var(--font-color);
  // position: absolute;
  @media screen and (max-width: 800px) {
    transform: translate(0%, -300%);
    margin-right: auto;
  }
  @media screen and (max-width: 500px) {
    transform: translate(0%, -300%);
    margin-right: auto;
  }
}
// /////////////////////////////////////////////////////////////////////////
.checkbox {
  direction: rtl;
  display: flex;
  // justify-content: center;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin-bottom: 20px;
  cursor: pointer;
  margin-top: 0.8em;
  // font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  // background: red;
  width: 100%;
}

/* Hide the browser's default checkbox */
.checkbox input {
  direction: rtl;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-100%, 30%);
  border-radius: 2px;
  height: 15px;
  width: 15px;
  background-color: var(--main-color);
  border: 1px solid #ccc;
  direction: rtl;
  @media screen and (max-width: 800px) {
    width: 10px;
    height: 10px;
  }
  @media screen and (max-width: 500px) {
    width: 10px;
    height: 10px;
  }
}
.product_list_brand__filters--container-check--title {
  @media screen and (max-width: 800px) {
    font-size: 0.8em;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.6em;
  }
}
/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
  background-color: var(--bg-color);
}

/* When the checkbox is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
  background-color: var(--shrink);
  border: none;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkmark:after {
  left: 5px;
  top: 3px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  @media screen and (max-width: 800px) {
    left: 3px;
    top: 1px;
    width: 2px;
    height: 5px;
  }
  @media screen and (max-width: 500px) {
    left: 3px;
    top: 1px;
    width: 2px;
    height: 5px;
  }
}
.ttt {
  margin-right: 3em;
  // margin-top: 1em;
  font-size: 0.9em;
  @media screen and (max-width: 500px) {
    // font-size: 0.6em;
    margin-top: 0.1em;
  }
}
.pagination {
  justify-content: space-evenly;
  align-items: center;
  display: flex;
  // background: red;
  // padding: 1.5em 20em;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  @media screen and (max-width: 500px) {
    width: 100%;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  // background: var(--bg-color);
  li {
    margin: 0 4px;
    padding: 0;
    list-style: none outside none;
    line-height: 5px;
    width: 100%;
    // background: chartreuse;
    a {
      border-radius: 3px;
      // background: var(--bg-color);
      // color: var(--font-color);
      // padding: 1em
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.9em;
      @media screen and (max-width: 500px) {
        font-size: 0.5em;
      }
    }
  }
  .active {
    color: var(--main-color);
    background: var(--sub-color);
  }
}
.page-item {
  border-radius: 3px;
  background: var(--bg-color);
  color: var(--font-color);
  // padding: 1em
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9em;
  @media screen and (max-width: 500px) {
    height: 25px;
  }
}
.kooom {
  // background: red;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  height: 250px;
  // overflow-y: scroll;
  // overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--main-color) var(--main-color);
  // border-bottom: 3px solid black;
}
// .kooom {
//   height: 250px;
//   overflow-y: scroll;
//   overflow-x: hidden;
//   scrollbar-width: thin;
//   scrollbar-color: var(--bg-color) var(--main-color);
//   // border-bottom: 3px solid black;
// }
.phone {
  display: none;
  border: none;
  background: var(--main-color);
  border-radius: 50%;
  padding: 0.3em;
  padding-right: 0.5em;
  padding-left: 0.45em;
  margin-left: 0.5em;
  margin-right: 0.5em;
  color: var(--font-color);
  // width: 20px;
  // height: 20px;
  border: 1px solid var(--sub-color);
  @media screen and (max-width: 1100px) {
    // display: ;
    display: inline;
  }
}
.filtclose {
  font-family: "yekan";
  cursor: pointer;
  display: none;
  color: var(--font-color);
  background: var(--main-color);
  border-radius: 6px;
  padding: 0.1em 0.75em;
  height: 27px;
  // font-size: 1em;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid var(--shrink);
  // display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  // margin-left: auto;
  .xew {
    color: var(--shrink);
    margin-right: 0.5em;
  }
  @media screen and (max-width: 1100px) {
    display: flex;
    // margin-left: 0.1em;
    margin-left: auto;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.8em;
    padding: 0.1em 0.75em;
    // margin-left: 0.05em;
    margin-left: auto;
  }
}

.dropdooown {
  // display: none;
  height: 0px;
  transition: all 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/brand/brand.vue